import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from "react-router-dom";
import { getEvent } from "../../../api/events.api";
import ErrorResponse from "../../../components/ErrorResponse";
import EducationReader1 from "../../../components/event/education/Reader1";
import EducationReader2 from "../../../components/event/education/Reader2";
import SimpleHeader from "../../../components/layout/SimpleHeader";
import Loader from "../../../components/Loader";
import useAxios from "../../../hooks/useAxios";
import { IGetEvent } from "../../../models/events.model";
import { RootState } from "../../../store/rootReducer";

interface IMatch {
  eventNo: string;
}

const EducationRead = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const eventNo = Number(match.params.eventNo);
  const { auth } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetEvent>();

  useEffect(() => {
    if (eventNo) {
      execute(getEvent('ED', eventNo));
    }
  }, [eventNo]);

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-event-big.svg"
        parentMenu={t('common.menu.event')}
        currentMenu={t('event.education.title4')}
      />
      {
        auth.hqYn === 'Y'
          ? <EducationReader1 data={res?.data} />
          : <EducationReader2 data={res?.data} />
      }
    </div>
  );
}

export default EducationRead;
